/**
 *
 * Filter Grid
 *
 */

( function () {
	'use strict';

	const html                  = document.querySelector( 'html' );
	const filterToggle          = document.querySelector( '.filter-toggle' );
	const filterClose           = document.querySelector( '.filter-grid__sidebar-close' );
	const filterGrid			= document.querySelector( '.filter-grid__sidebar' );
	const filterOverlay         = document.querySelector( '.filter-overlay' );

	/**
	 * Toggle Filter Menu
	 */
	const toggleFilters = () => {
		html.classList.toggle( 'filter-open' );
	};

	/**
	 * Close Filter Menu
	 */
	const closeFilters = () => {
		html.classList.remove( 'filter-open' );
		$( filterGrid ).trigger( 'filter:close' );
	};

	if( null != filterToggle ) {
		filterToggle.addEventListener( 'click', toggleFilters );
		filterClose.addEventListener( 'click', closeFilters );
		filterOverlay.addEventListener( 'click', closeFilters );
	}

} )();

/**
 * Mobile Filter Toggle
 */
( function( $ ) {
	'use strict';

	$( window ).on( 'scroll', () => {
		var scrollTop = $( window ).scrollTop();
		if( 450 <= scrollTop ) {
			$( '.filter-toggle__mobile' ).addClass( 'filter-toggle__mobile--is-visible' );
		}
		if( 449 >= scrollTop ) {
			$( '.filter-toggle__mobile' ).removeClass( 'filter-toggle__mobile--is-visible' );
		}
	} );

	$( '.filter-toggle__mobile' ).on( 'click', function() {
		$( 'html' ).toggleClass( 'filter-open' );
	} );

} )( jQuery );
